import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";
import { showToast } from "./ToastSlice";

/* ------------------------------------------------------------------ */
/* ASYNC THUNKS */
/* ------------------------------------------------------------------ */

// 🔹 Create WABA Template
export const createWabaTemplate = createAsyncThunk(
  "wabaTemplates/create",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      console.log(payload, "payload before going to create template api");
      for (const [key, value] of payload.entries()) {
        console.log(key, value, "formdata payload");
      }

      const res = await api.post("api/whatsapp/create-template", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
console.log(res.data,"response from create template");

      dispatch(showToast({ message: res.data.message, variant: "success" }));

      return res.data.data; // newWabaTemplate
    } catch (err) {
      const data = err.response?.data;
      const msg = data?.metaError?.error_user_msg || data?.metaError?.error_user_title || data?.message || "Failed to create template";
      dispatch(showToast({ message: msg, variant: "error" }));
      return rejectWithValue(msg);
    }
  },
);
/* ------------------------------------------------------------------ */
// 🔹 Edit WABA Template
export const editWabaTemplate = createAsyncThunk(
  "wabaTemplates/edit",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      console.log(payload, "payload before going to edit template api");
      // Log FormData entries
      for (const [key, value] of payload.entries()) {
        console.log(key, value, "formdata payload");
      }

      const res = await api.put("api/whatsapp/edit-template", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log(res.data, "response from edit template");

      dispatch(showToast({ message: res.data.message, variant: "success" }));

      return res.data.data; // updated template
    } catch (err) {
      const data = err.response?.data;
      const msg = data?.metaError?.error_user_msg || data?.metaError?.error_user_title || data?.message || "Failed to edit template";
      dispatch(showToast({ message: msg, variant: "error" }));
      return rejectWithValue(msg);
    }
  },
);

// 🔹 Get & Sync WABA Templates
export const fetchWabaTemplates = createAsyncThunk(
  "wabaTemplates/fetchAll",
  async (payload, { rejectWithValue }) => {
    try {
      
      const res = await api.post("api/whatsapp/get-waba-templates",payload);


return {
  templates: res.data.data,
  pagination: res.data.pagination,
};

      // return res.data.data; // syncedTemplates
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch templates",
      );
    }
  },
);

// 🔹 Delete WABA Template
export const deleteWabaTemplate = createAsyncThunk(
  "wabaTemplates/delete",
  async (templateName, { rejectWithValue }) => {
    try {
      await api.delete("api/whatsapp/delete-waba-template", {
        params: { name: templateName },
      });
      return templateName;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete template",
      );
    }
  },
);

/* ------------------------------------------------------------------ */
/* SLICE */
/* ------------------------------------------------------------------ */

const WabaTemplateSlice = createSlice({
  name: "wabaTemplates",
  initialState: {
    wabaTemplates: [],
    pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearWabaTemplateState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------------- CREATE ---------------- */
      .addCase(createWabaTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createWabaTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.wabaTemplates.unshift(action.payload);
      })
      .addCase(createWabaTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------------- FETCH ---------------- */
      .addCase(fetchWabaTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWabaTemplates.fulfilled, (state, action) => {
        state.loading = false;
        // state.wabaTemplates = action.payload;
        state.wabaTemplates = action.payload.templates;
state.pagination = action.payload.pagination;

      })
      .addCase(fetchWabaTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

 /* ---------------- EDIT ---------------- */
.addCase(editWabaTemplate.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(editWabaTemplate.fulfilled, (state, action) => {
  state.loading = false;
  state.success = true;
  // Replace the updated template in state
  state.wabaTemplates = state.wabaTemplates.map(t =>
    t._id === action.payload._id ? action.payload : t
  );
})
.addCase(editWabaTemplate.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})



      /* ---------------- DELETE ---------------- */
      .addCase(deleteWabaTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteWabaTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.wabaTemplates = state.wabaTemplates.filter(
          (t) => t.name !== action.payload,
        );
      })
      .addCase(deleteWabaTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

/* ------------------------------------------------------------------ */
/* EXPORTS */
/* ------------------------------------------------------------------ */

export const { clearWabaTemplateState } = WabaTemplateSlice.actions;

export default WabaTemplateSlice.reducer;
